module.exports = __webpack_public_path__ + "static/vista-explodida-4-pt-0fd72bd23d0480c47e68cf3c9489db1c.png";